'use client';
import React from 'react';
import Link from 'next/link';

export default function TopBar() {
  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 60, height: 60,
      background: 'rgba(16,16,17,.82)',
      backdropFilter: 'blur(14px)',
      borderBottom: '1px solid rgba(228,228,229,.1)',
    }}>
      <div style={{
        maxWidth: 'var(--measure)', margin: '0 auto', height: '100%',
        padding: '0 clamp(14px,2.5vw,24px)',
        display: 'flex', alignItems: 'center', gap: 14,
      }}>
        <Link
          href="/"
          className="topbar-brand"
          style={{ display: 'none', alignItems: 'center', gap: 8 }}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="https://zecbit.net/zb-logo.png" alt="ZecBit" width={34} height={16} style={{ width: 34, height: 'auto', imageRendering: 'pixelated', display: 'block' }} />
          <span style={{ fontFamily: 'var(--pixel)', fontSize: 12, color: 'var(--gold)', letterSpacing: 1 }}>ZECBIT</span>
        </Link>
        <div style={{ flex: 1 }} />
        <div className="topbar-wallet" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            display: 'flex', alignItems: 'center', gap: 6,
            fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: '0.6px',
            color: 'rgba(244,183,40,.8)',
            background: 'rgba(244,183,40,.07)',
            border: '1px solid rgba(244,183,40,.2)',
            borderRadius: 999, padding: '4px 11px',
            whiteSpace: 'nowrap',
          }}>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
              <path d="M12 2l8 3.5V11c0 5-3.4 8.6-8 10-4.6-1.4-8-5-8-10V5.5z" />
            </svg>
            You just need your shielded address · No wallet connection required · Shielded on Zcash
          </div>
        </div>
      </div>
    </header>
  );
}
